// axios
import axios from 'axios'

const baseURL = process.env.api

axios.defaults.headers.common['Content-Type'] = `application/json`;
axios.defaults.headers.common['X-Requested-With'] = `XMLHttpRequest`;
if (localStorage.accessToken) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.accessToken}`
}
axios.defaults.withCredentials = true
export default axios.create({
  baseURL
  // You can add your headers here
})
